
import React from 'react';
import { Upload, Trash2, RefreshCw, Play, LayoutList, LayoutGrid } from 'lucide-react';

interface ToolbarProps {
  onFileUpload: (e: React.ChangeEvent<HTMLInputElement>) => void;
  workItemsCount: number;
  onClearAll: () => void;
  isProcessing: boolean;
  onRunBatch: () => void;
  viewMode: 'list' | 'gallery';
  setViewMode: (mode: 'list' | 'gallery') => void;
}

export const Toolbar: React.FC<ToolbarProps> = ({ 
    onFileUpload, workItemsCount, onClearAll, isProcessing, onRunBatch,
    viewMode, setViewMode
}) => {
  return (
    <div className="bg-slate-900/50 p-4 flex items-center gap-4 border-b border-slate-800 shrink-0 relative z-20 shadow-sm">
      
      {/* View Mode Switcher */}
      <div className="flex bg-slate-950 p-1 rounded-lg border border-slate-800 mr-2">
        <button 
          onClick={() => setViewMode('list')}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-bold transition-all ${viewMode === 'list' ? 'bg-indigo-600 text-white shadow-lg' : 'text-slate-500 hover:text-slate-300'}`}
          title="列表视图"
        >
          <LayoutList size={14} />
          <span>列表</span>
        </button>
        <button 
          onClick={() => setViewMode('gallery')}
          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-bold transition-all ${viewMode === 'gallery' ? 'bg-indigo-600 text-white shadow-lg' : 'text-slate-500 hover:text-slate-300'}`}
          title="画廊视图"
        >
          <LayoutGrid size={14} />
          <span>画廊</span>
        </button>
      </div>

      <label className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg cursor-pointer transition-colors shadow-lg shadow-indigo-900/20 font-medium text-sm select-none">
        <Upload size={16} /> 导入 CSV
        <input type="file" accept=".csv" className="hidden" onChange={onFileUpload} />
      </label>

      <div className="h-6 w-px bg-slate-700 mx-2"></div>
      
      {workItemsCount > 0 && (
          <button 
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onClearAll();
            }}
            className="flex items-center gap-2 px-3 py-2 bg-red-500/10 hover:bg-red-500/20 text-red-400 border border-red-500/20 rounded-lg text-sm font-medium transition-colors select-none active:scale-95"
            title="清空所有任务"
          >
             <Trash2 size={16} /> 清空列表
          </button>
      )}

      <button 
        type="button"
        onClick={onRunBatch}
        disabled={workItemsCount === 0 || isProcessing}
        className="flex items-center gap-6 px-6 py-2 bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-500 hover:to-teal-500 text-white rounded-lg text-sm font-bold shadow-lg shadow-emerald-900/20 disabled:opacity-50 transition-all ml-auto select-none active:scale-[0.98]"
      >
        {isProcessing ? <RefreshCw className="animate-spin" size={16} /> : <Play size={16} fill="currentColor" />}
        批量生成
      </button>
    </div>
  );
};
